module.exports = __webpack_public_path__ + "img/voucher-de-desconto.c9663f92.png";